/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationProperties200ResponseMeta } from './GetOrganizationProperties200ResponseMeta';
import {
    GetOrganizationProperties200ResponseMetaFromJSON,
    GetOrganizationProperties200ResponseMetaFromJSONTyped,
    GetOrganizationProperties200ResponseMetaToJSON,
    GetOrganizationProperties200ResponseMetaToJSONTyped,
} from './GetOrganizationProperties200ResponseMeta';
import type { OrganizationLinkedContact } from './OrganizationLinkedContact';
import {
    OrganizationLinkedContactFromJSON,
    OrganizationLinkedContactFromJSONTyped,
    OrganizationLinkedContactToJSON,
    OrganizationLinkedContactToJSONTyped,
} from './OrganizationLinkedContact';

/**
 * 
 * @export
 * @interface OrganizationContactsResponse
 */
export interface OrganizationContactsResponse {
    /**
     * 
     * @type {Array<OrganizationLinkedContact>}
     * @memberof OrganizationContactsResponse
     */
    contacts: Array<OrganizationLinkedContact>;
    /**
     * 
     * @type {GetOrganizationProperties200ResponseMeta}
     * @memberof OrganizationContactsResponse
     */
    meta?: GetOrganizationProperties200ResponseMeta;
}

/**
 * Check if a given object implements the OrganizationContactsResponse interface.
 */
export function instanceOfOrganizationContactsResponse(value: object): value is OrganizationContactsResponse {
    if (!('contacts' in value) || value['contacts'] === undefined) return false;
    return true;
}

export function OrganizationContactsResponseFromJSON(json: any): OrganizationContactsResponse {
    return OrganizationContactsResponseFromJSONTyped(json, false);
}

export function OrganizationContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(OrganizationLinkedContactFromJSON)),
        'meta': json['meta'] == null ? undefined : GetOrganizationProperties200ResponseMetaFromJSON(json['meta']),
    };
}

export function OrganizationContactsResponseToJSON(json: any): OrganizationContactsResponse {
    return OrganizationContactsResponseToJSONTyped(json, false);
}

export function OrganizationContactsResponseToJSONTyped(value?: OrganizationContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contacts': ((value['contacts'] as Array<any>).map(OrganizationLinkedContactToJSON)),
        'meta': GetOrganizationProperties200ResponseMetaToJSON(value['meta']),
    };
}

